import React from "react";
import { ArrowDownIcon, ArrowRightIcon, CheckCircle2Icon, XCircleIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { afterItems, beforeItems } from "../../data/framework";
export function BeforeAfterSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-98" data-mp="3fdr10ph55m0v">
      <div className="mx-auto max-w-6xl" data-id="element-99" data-mp="3fgdfl92g91sl">
        <SectionHeading eyebrow="Before & After" title="What Changes When You Understand the System?" data-id="element-100" data-mp="6zs49lmchwmb" />

        <div className="mt-10 grid items-stretch gap-4 lg:grid-cols-[1fr_auto_1fr] lg:gap-6" data-id="element-101" data-mp="bwsdu6ielhi6">
          <div className="rounded-3xl border-2 border-danger/25 bg-danger-soft p-5 sm:p-7" data-id="element-102" data-mp="3tda8rh61ivcn">
            <p className="inline-block rounded-full bg-danger px-4 py-1.5 text-sm font-black uppercase tracking-wider text-white" data-id="element-103" data-mp="278uz0uoxnnb">
              Before
            </p>
            <h3 className="mt-4 text-xl font-black text-ink sm:text-2xl" data-id="element-104" data-mp="uobg2b4lsrj5">Working With Disconnected Information</h3>
            <ul className="mt-5 space-y-3.5" data-id="element-105" data-mp="22nl1g7oi63hp">
              {beforeItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-snug text-ink" data-id="element-106" data-mp="1xp9qftmh1mxw">
                  <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-107" data-mp="2cefmx9txcz23" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="flex items-center justify-center" aria-hidden="true" data-id="element-108" data-mp="2lec6ix1gj7qa">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-brand text-white shadow-cta" data-id="element-109" data-mp="2lgf5w7oi2d7o">
              <ArrowDownIcon className="h-6 w-6 lg:hidden" data-id="element-110" data-mp="2vci4x4o21vqe" />
              <ArrowRightIcon className="hidden h-6 w-6 lg:block" data-id="element-111" data-mp="2vc09ubd4pnk2" />
            </span>
          </div>

          <div className="rounded-3xl border-2 border-success/30 bg-success-soft p-5 sm:p-7" data-id="element-112" data-mp="2qbm3cxr6elo5">
            <p className="inline-block rounded-full bg-success px-4 py-1.5 text-sm font-black uppercase tracking-wider text-white" data-id="element-113" data-mp="10z0qq89jib81">
              After
            </p>
            <h3 className="mt-4 text-xl font-black text-ink sm:text-2xl" data-id="element-114" data-mp="1louw0txh1f32">With SELF-LIGATING ORTHODONTICS BLUEPRINT™</h3>
            <ul className="mt-5 space-y-3.5" data-id="element-115" data-mp="1ppwvnbvavt5k">
              {afterItems.map(item => <li key={item} className="flex items-start gap-3 text-[15px] font-semibold leading-snug text-ink" data-id="element-116" data-mp="1unpzhy94sb2o">
                  <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-117" data-mp="1zovy2cph2sk4" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-10 text-center text-xl font-black text-ink sm:text-2xl" data-id="element-118" data-mp="28m6ba3luorro">
          Less scattered information. <span className="text-brand" data-id="element-119" data-mp="2ie2ji7hnhy9m">More structured clinical thinking.</span>
        </p>

        <SectionCta label="I Want to Understand Self-Ligating Orthodontics" data-id="element-120" data-mp="2ifwscnfndzxc" />
      </div>
    </section>;
}